export default __webpack_public_path__ + "static/media/vaca-2.36759933.png";